import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get(params.url, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", []);

        resp.data.itens.forEach(item => {
          item.url = params.link.concat(
            '&data_emissao=',
            item.data_emissao,
            '&name=',
            params.idpedido,
            '&parcela=',
            item.parcela
          )

          item.target = params.target;
          commit("setItem", item);
        });

        if (resp.data.itens.length === 0) {
          window.open(params.link + "&name=" + params.idpedido, "self");
        } else {
          commit("setSheet", true);
        }
      })
      .catch(() => {
        // Helpers.logout();
      });
  }
};
